export { WallGame } from './main';
